import { Button, Menu, Modal, Stack, TextInput } from '@mantine/core';
import { IconCheck, IconChevronDown, IconPlus, IconSettings } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useActivateWorkspace, useCreateWorkspace, useWorkspaces } from '@/api/workspace';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { useApiError } from '@/hooks/useApiError';

/** Workspace-Wechsler in der Kopfzeile (UI-01, WS-05). */
export function WorkspaceSwitcher() {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const navigate = useNavigate();
  const { data: workspaces = [] } = useWorkspaces();
  const activate = useActivateWorkspace();
  const create = useCreateWorkspace();
  const onError = useApiError();
  const [createOpen, setCreateOpen] = useState(false);
  const [name, setName] = useState('');

  return (
    <>
      <Menu position="bottom-start" width={260} withinPortal>
        <Menu.Target>
          <Button variant="subtle" color="gray" rightSection={<IconChevronDown size={14} />} visibleFrom="xs" styles={{ label: { maxWidth: 200 } }}>
            {ctx.workspace.name}
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>{t('header.workspaces')}</Menu.Label>
          {workspaces.map((w) => (
            <Menu.Item
              key={w.id}
              rightSection={w.id === ctx.workspaceId ? <IconCheck size={14} /> : null}
              onClick={() => w.id !== ctx.workspaceId && activate.mutate(w.id, { onSuccess: () => navigate('/tracker'), onError })}
            >
              {w.name}
            </Menu.Item>
          ))}
          <Menu.Divider />
          {ctx.isAdmin && (
            <Menu.Item leftSection={<IconSettings size={14} />} onClick={() => navigate('/settings')}>
              {t('header.workspaceSettings')}
            </Menu.Item>
          )}
          <Menu.Item leftSection={<IconPlus size={14} />} onClick={() => setCreateOpen(true)}>
            {t('header.createWorkspace')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <Modal opened={createOpen} onClose={() => setCreateOpen(false)} title={t('header.createWorkspace')}>
        <Stack>
          <TextInput label={t('workspace.name')} value={name} onChange={(e) => setName(e.currentTarget.value)} data-autofocus />
          <Button
            disabled={!name.trim()}
            loading={create.isPending}
            onClick={() =>
              create.mutate(name, {
                onSuccess: () => {
                  setCreateOpen(false);
                  setName('');
                  navigate('/tracker');
                },
                onError,
              })
            }
          >
            {t('common.create')}
          </Button>
        </Stack>
      </Modal>
    </>
  );
}
